<template>
  <div class="productSpecification">
    <div class="productSpecification__inner">
      <h3 class="productSpecification__title">
        {{ title }}
      </h3>
      <div class="productSpecification__table">
        <div v-for="(item, index) in data" :key="index" class="productSpecification__row">
          <div class="productSpecification__rowItem">
            {{ item.name }}
          </div>
          <div class="productSpecification__rowItem">
            {{ item.value }}
          </div>
        </div>
        <div v-if="producent && producent.length" class="productSpecification__row">
          <div class="productSpecification__rowItem">Bezpieczeństwo produktu</div>
          <div class="productSpecification__rowItem">
            <button @click="openInfo(producent, 'producent', 'Producent')">Producent</button>
            <template>
              <br />
              <button
                v-if="safetyInformations && safetyInformations.length"
                @click="openInfo(safetyInformations, 'info', 'Bezpieczeństwo, ostrzeżenia')"
              >
                Bezpieczeństwo, ostrzeżenia
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'ProductSpecification',
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => {},
    },
    producent: {
      type: Array,
      default: () => {},
    },
    safetyInformations: {
      type: Array,
      default: () => {},
    },
  },
  methods: {
    ...mapMutations({
      pushModal: 'modal/pushModal',
    }),
    openInfo(data, type, title) {
      this.pushModal({
        modal: {
          name: 'modalProducentInfo',
          path: 'Product/ModalProducentInfo',
          title: title || 'Producent',
          footerDisabled: true,
        },
        data: {
          type,
          info: data,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.productSpecification {
  background-color: $cWhite;
  padding-bottom: 4.5rem;

  &__table {
    border-top: 1px solid $cAddLight;
  }

  &__row {
    display: flex;
    border-bottom: 1px solid $cAddLight;
    &:nth-child(odd) {
      background-color: $cAddSuperLight;
    }
  }

  &__rowItem {
    flex: 0 0 50%;
    max-width: 50%;
    padding-top: 1.2rem;
    padding-bottom: 1.2rem;
    font-size: 1.4rem;
    line-height: 2.2rem;
    font-weight: 600;
    color: $cAddDark02;

    @include rwd('small-tablet') {
      padding-right: 2rem;
    }

    &:first-child {
      font-weight: 400;
      color: $cMainDark;
      padding-left: 3rem;

      @include rwd('small-tablet') {
        flex: 0 0 50%;
        max-width: 50%;
        padding-left: 2rem;
      }
    }

    button {
      text-decoration: underline;
      transition: opacity $tr;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
